import {OrgCreditCard} from "./org-credit-card";

export class PartnerCreditCard extends OrgCreditCard {
  partnerId: number;
}
